import { Invoice, SharedProps } from '@/types'
import { router, usePage } from '@inertiajs/react'
import { useState } from 'react'

// The row actions of the invoice list and the buttons of an invoice's page do the same things.
export function useInvoiceActions() {
  const { current_organization } = usePage<SharedProps>().props
  const [payingInvoice, setPayingInvoice] = useState<Invoice | null>(null)

  const invoicePath = (invoice: Invoice) => `/organizations/${current_organization?.slug}/invoices/${invoice.id}`

  const resend = (invoice: Invoice) => {
    if (!confirm(`Renvoyer la facture ${invoice.number} à la plateforme ?`)) return
    router.post(`${invoicePath(invoice)}/delivery`)
  }

  const cancelAndRedo = (invoice: Invoice) => {
    const message =
      `Annuler la facture ${invoice.number} ? Ses dépôts redeviennent facturables et vous pourrez refaire la ` +
      'facture sous un nouveau numéro.'
    if (!confirm(message)) return
    router.post(`${invoicePath(invoice)}/cancellation`)
  }

  const openPdf = (invoice: Invoice) => window.open(`${invoicePath(invoice)}/document.pdf`, '_blank')

  const startPayment = (invoice: Invoice) => setPayingInvoice(invoice)

  const closePayment = () => setPayingInvoice(null)

  return { invoicePath, resend, cancelAndRedo, openPdf, payingInvoice, startPayment, closePayment }
}
